import React, { useState } from "react";
import NavbarComponent from "../components/navbar.component";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import "../assets/sass/course-detail.scss";
import { Col, Container, Row } from "reactstrap";
import Footer from "../components/footer.component";

import { useQuery } from "react-query";
import axios from "axios";

import { IP } from "../api/ip";
import { formatFullDate } from "../utils/formatter";

import SearchCourses from "../components/home/search-courses.component";
import ProfileTable from "../components/profile/profileTable.component";

import ScheduleTable from "../components/scheduleTable.component";
import { handleScrollToTop } from "../utils/helperFunction";
const SchedulePage = () => {
  document.title = " جدول | صناع السعادة";
  const [searchData, setSearchData] = useState(null);
  const [searchLoading, setSearchLoading] = useState(null);

  const handleSearchResults = (results) => {
    setSearchData(results);
  };

  return (
    <>
      <div className="course-detail-wrapper">
        <NavbarComponent activePage={"schedule"} />
        <div className="course-detail-header d-flex align-items-center justify-content-end px-5">
          <h1>جدول</h1>
        </div>

        <SearchCourses
          onSearchResults={handleSearchResults}
          searchLoading={(load) => setSearchLoading(load)}
        />
      </div>

      <div className="container schedule-table-wrapper">
        <ScheduleTable data={searchData} searchLoading={searchLoading} />
      </div>

      <Footer scroll={handleScrollToTop} />
    </>
  );
};

export default SchedulePage;
